import Header from "../components/header";
import MediaAndText from "../components/media-and-text";
import PricingHolder from "../components/pricing-holder";
import SubpageHero from "../components/subpage-hero";

// Optional: tweak these paths to match your actual screenshots
const FOUNDER_IMG = "./images/stock/shannon-rowies-3RTR4Zt7E5c-unsplash.jpg";
const MARKETER_IMG = "./images/stock/austin-distel-21GWwco-JBQ-unsplash.jpg";
const THOUGHTLEADER_IMG = "./images/stock/bruce-mars-FWVMhUa_wbY-unsplash.jpg";
const HEADER_IMG = "./images/product-screenshots/shot.png";

function UseCasePage() {
  const navigateToSignup = () => {
    window.location.href = "/signup";
  };

  const navigateToLogin = () => {
    window.location.href = "/login";
  };

  return (
    <>
      <Header
        hideIcons={true}
        CTA="Sign up"
        functionForButton={navigateToSignup}
        CTA2="Log in"
        functionForButton2={navigateToLogin}
      />

      <main className="homepage">
        {/* HERO */}
        <SubpageHero
          headline="Use cases for Mako"
          tag="How Mako can help you"
          desc="Mako turns market noise into signal — tracking the sites that matter and surfacing Insights so you can focus on judgment instead of endless reading."
          img={HEADER_IMG}
        />

        {/* PRODUCT SECTIONS USING YOUR EXISTING COMPONENTS */}

        <MediaAndText
          heading="For early-stage founders: stay ahead of the market while you build"
          text="You’re juggling product, hiring, sales and fundraising — but your market still moves every day. Mako monitors the sites and competitors that matter, surfaces the trends worth your attention, and turns them into clear Insights. When something shifts, you’ll know early — so you can react while it’s still relevant instead of losing an afternoon to research."
          image={FOUNDER_IMG}
          reversed
        />

        <MediaAndText
          heading="For early-stage marketers: run multi-voice LinkedIn without the chaos"
          text="Mako helps you run a consistent content engine across your company — even when you’re a team of one. Track your market, collect Insights you can turn into campaign angles, and coordinate angles across teams quickly. With up to 10 voices, each founder, sales leader or expert keeps the right tone, persona and ICP — then schedule everything in one place."
          image={MARKETER_IMG}
        />

        <MediaAndText
          heading="For aspiring thought leaders: get the signal without the scroll"
          text="Thought leadership isn’t about posting more - it’s about seeing what others miss and explaining it clearly. Mako monitors up to 10 sites in your niche and delivers a feed of fresh ideas, updates and shifts. Then Insights connects the dots for you, so you can write with authority - without manually reading hundreds of posts to find a real angle."
          image={THOUGHTLEADER_IMG}
          reversed
        />


        {/* PRICING */}
        <section className="pricing-section">
          <PricingHolder />
        </section>
      </main>
    </>
  );
}

export default UseCasePage;
